import KioskDomainField from './KioskDomainField';
import KioskGroupsField from './KioskGroupsField';
import KioskSubscriptionsField from './KioskSubscriptionsField';

export default [
    {
        id: 'kiosk-domain',
        component: KioskDomainField,
    },
    {
        id: 'kiosk-subscriptions',
        component: KioskSubscriptionsField,
    },
    {
        id: 'kiosk-groups',
        component: KioskGroupsField,
    },
];
